// frontend/src/apiClient.js
import axios from "axios";

const RUNTIME_ORIGIN = window.__ENV?.API_ORIGIN;          // 來自 env.js
const BUILD_ORIGIN = process.env.REACT_APP_API_ORIGIN;    // build 時設定
export const API_ORIGIN = RUNTIME_ORIGIN || BUILD_ORIGIN || "";
// export const API_ORIGIN = "http://localhost:5000";
console.log("API_ORIGIN:", API_ORIGIN)


export const api = axios.create({
  baseURL: API_ORIGIN,
  // 如果之後要帶 cookie：
  // withCredentials: true,
});

// 自動夾帶 token（但不覆蓋既有 header）
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("flaskAccessToken");
  // 如果前端沒帶 Authorization 才加
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 可傳進一個取 token 的方法，避免把 token 長期放 localStorage
export function createApiClient({ getToken } = {}) {
  async function request(path, { method = 'GET', headers = {}, body, signal } = {}) {
    const url = `${API_ORIGIN}${path.startsWith('/') ? '' : '/'}${path}`;

    const h = new Headers(headers);
    h.set('Accept', 'application/json');

    // 若是 JSON，就設定 Content-Type
    if (body && !(body instanceof FormData)) {
      h.set('Content-Type', 'application/json');
      body = JSON.stringify(body);
    }

    // 自動加 JWT
    const token = getToken ? getToken() : null;
    if (token) h.set('Authorization', `Bearer ${token}`);

    const res = await fetch(url, { method, headers: h, body, signal });
    // 2xx 以外視為錯誤（可依需求放寬）
    if (!res.ok) {
      let errPayload;
      try { errPayload = await res.json(); } catch {}
      const msg = errPayload?.message || errPayload?.error || res.statusText;
      const error = new Error(msg);
      error.status = res.status;
      error.payload = errPayload;
      throw error;
    }
    // 沒內容直接回 null
    if (res.status === 204) return null;

    // 嘗試解析 JSON
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) return res.json();

    return res.text();
  }

  return {
    get: (path, opts) => request(path, { ...opts, method: 'GET' }),
    post: (path, body, opts) => request(path, { ...opts, method: 'POST', body }),
    put: (path, body, opts) => request(path, { ...opts, method: 'PUT', body }),
    del: (path, opts) => request(path, { ...opts, method: 'DELETE' }),
    request,
  };
}
